
import { defineComponent, toRaw } from "vue"

export default defineComponent({
  data: () => ({
    cards: toRaw([
      {
        title: "Региональные <br> этапы",
        date: "1&nbsp;июля&nbsp;— 20&nbsp;сентября 2024",
        text: "не&nbsp;позднее 18&nbsp;часов (по&nbsp;московскому времени).",
      },
      {
        title: "Всероссийский <br> этап",
        date: "21&nbsp;сентября&nbsp;— 21&nbsp;октября 2024",
        text: "не&nbsp;позднее 18&nbsp;часов (по&nbsp;московскому времени).",
      },
    ] as const),
  }),
})
